import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { IoClose, IoPlay } from "react-icons/io5";
import { trackCTAClicked } from "../../utils/analytics";
import "../../styles/HowItWorksVideoButton.css";

const HOMEOWNER_VIDEO_ID = "KfcudvXwVuU";

const HowItWorksVideoButton = () => {
  const [open, setOpen] = useState(false);
  const [overHeroBox, setOverHeroBox] = useState(false);

  useEffect(() => {
    if (
      typeof window === "undefined" ||
      typeof IntersectionObserver === "undefined" ||
      !window.matchMedia
    ) {
      return undefined;
    }
    const phone = window.matchMedia("(max-width: 767px)");
    const box = document.querySelector(".estimator-input-container");
    if (!box) return undefined;

    let visible = false;
    const update = () => setOverHeroBox(phone.matches && visible);
    const observer = new IntersectionObserver(([entry]) => {
      visible = entry.isIntersecting;
      update();
    });
    observer.observe(box);
    if (phone.addEventListener) phone.addEventListener("change", update);
    return () => {
      observer.disconnect();
      if (phone.removeEventListener) phone.removeEventListener("change", update);
    };
  }, []);

  useEffect(() => {
    if (!open) return undefined;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  return (
    <>
      <button
        type="button"
        className={`hiw-video-fab${overHeroBox ? " hiw-video-fab--hidden" : ""}`}
        aria-hidden={overHeroBox ? "true" : undefined}
        tabIndex={overHeroBox ? -1 : undefined}
        onClick={() => {
          trackCTAClicked("homepage_video_button", "video");
          setOpen(true);
        }}
        aria-label="Play video: how Pricing Penguin works"
      >
        <span className="hiw-video-fab-icon" aria-hidden="true">
          <IoPlay />
        </span>
        <span className="hiw-video-fab-label">How It Works</span>
      </button>

      {open &&
        createPortal(
          <div className="hiw-video-overlay" onMouseDown={() => setOpen(false)}>
            <div
              className="hiw-video-dialog"
              role="dialog"
              aria-modal="true"
              aria-label="How Pricing Penguin works"
              onMouseDown={(e) => e.stopPropagation()}
            >
              <button
                type="button"
                className="hiw-video-close"
                onClick={() => setOpen(false)}
                aria-label="Close video"
              >
                <IoClose aria-hidden="true" />
              </button>
              <div className="hiw-video-frame">
                <iframe
                  src={`https://www.youtube.com/embed/${HOMEOWNER_VIDEO_ID}?rel=0&playsinline=1&autoplay=1`}
                  title="Pricing Penguin for Homeowners"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            </div>
          </div>,
          document.body
        )}
    </>
  );
};

export default HowItWorksVideoButton;
